module.exports = __webpack_public_path__ + "src/assets/images/logos/carriers/CO//COLogo.jpg";